import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {H2hClickEvent} from "../models/events/h2h.click-event";

export class H2hClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.h2hClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = H2hClickEvent;
  }
}
